import { SelectField } from '@servicetitan/anvil2-react-hook-form';
import { incomeTypes } from '@servicetitan/financing-utils-shared';
import { CSSProperties } from 'react';

interface IncomeTypeComboboxProps {
    fieldPrefix?: string;
    style?: CSSProperties;
}

export const IncomeTypeCombobox = ({ fieldPrefix, style }: IncomeTypeComboboxProps) => {
    const incomeTypeValues = Object.values(incomeTypes);
    const options = incomeTypeValues.map(type => ({ id: type, label: type }));

    const fieldName = fieldPrefix
        ? `${fieldPrefix}.employment.incomeType`
        : 'employment.incomeType';

    return (
        <SelectField
            name={fieldName}
            options={options}
            label="Income Type"
            required
            style={style}
        />
    );
};
